export enum CpCeEnum {
    cisloPopisne = 'CP',
    cisloEvidencni = 'CE',
}